import React from 'react';
import TableCell from '@mui/material/TableCell';

export default ({ children, className, colSpan, style, onClick }) => (
  <TableCell colSpan={colSpan} onClick={onClick} className={className} style={{ padding: '4px', ...style }}>
    {children}
  </TableCell>
);
